export const Geometry = {
    None: "none",
    Bigon: "bigon",
    Square: "square",
    Hexagon: "hexagon",
};
export class Point {
    x;
    y;
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    fn = (f) => {
        const [nx, ny] = f(this.x, this.y);
        return new Point(nx, ny);
    };
    add = (q) => this.fn((x, y) => [x + q.x, y + q.y]);
    sub = (q) => this.add(q.mul(-1));
    mul = (k) => this.fn((x, y) => [k * x, k * y]);
    angle = () => Math.atan2(this.y, this.x);
    angleTo = (q) => this.sub(q).angle();
    matMul = ([[a, b], [c, d]]) => this.fn((x, y) => [a * x + b * y, c * x + d * y]);
    rotate = (angle) => {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        return this.matMul([
            [cos, -sin],
            [sin, cos],
        ]);
    };
    rotateAround = (angle, q) => this.sub(q).rotate(angle).add(q);
    geometrizeAngles = (geometry, o) => {
        switch (geometry) {
            case Geometry.None: {
                return [0];
            }
            case Geometry.Bigon: {
                return [this.angleTo(o)];
            }
            case Geometry.Square: {
                return [0, Math.PI];
            }
            case Geometry.Hexagon: {
                return [0, (Math.PI * 2) / 3, (Math.PI * 4) / 3];
            }
        }
    };
    with = (dancer) => ({
        ...dancer,
        x: this.x,
        y: this.y,
    });
    static from = ({ x, y }) => new Point(x, y);
}
export function geometrize(dancer, geometry, origin) {
    const p = Point.from(dancer);
    const o = Point.from(origin);
    const angles = p.geometrizeAngles(geometry, o);
    return angles.map((angle, i) => ({
        ...p.rotateAround(angle, o).with(dancer),
        rotate: (angles[i] * 180) / Math.PI,
    }));
}
//# sourceMappingURL=geometry.js.map